import React from 'react';

import styles from './SiteParameters.module.scss';

interface IParameterItemProps {
	value: string | number;
	label: string;
	dataTestIdForValue?: string;
}

const ParameterItem = ({ value, label, dataTestIdForValue }: IParameterItemProps) => {
	return (
		<div className={styles.paramItemContainer}>
			<span className={styles.paramName}>{label}: </span>
			<span data-testid={dataTestIdForValue || label}>{value || 'N/A'}</span>
		</div>
	);
};

export default ParameterItem;
